<template>
  <custom-dialog :title="`Delete ${row.name}`">
    <template
      ><h2>
        Are you sure you want to delete {{ _.lowerCase(row.item) }}?
      </h2></template
    >
    <template #footer-btn>
      <el-button class="btn btn-form btn-pink btn-footer" @click="submit()"
        >Delete</el-button
      >
    </template>
  </custom-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import CustomDialog from "@/components/base/customDialog";
export default {
  props: {
    row: Object,
  },
  components: {
    CustomDialog,
  },
  methods: {
    async submit() {
      const setObj = {
        is_archived: true,
      };
      switch (this.row.item) {
        case CONSTANT.DIALOG_TYPE.CREATIVE:
          if (this.row.id) {
            await store.dispatch("creative/patchCreativeById", {
              id: this.row.id,
              setObj: setObj,
            });
          } else {
            await store.dispatch("creative/patchCreatives", {
              setObj: setObj,
            });
          }
          break;
        case CONSTANT.DIALOG_TYPE.CREATIVE_FOLDER:
          await store.dispatch("creativeFolder/patchCreativeFolderById", {
            id: this.row.id,
            setObj: setObj,
          });
          break;
        case CONSTANT.DIALOG_TYPE.ASSET:
          await store.dispatch("asset/patchAssetById", {
            id: this.row.id,
            setObj: setObj,
          });
          break;
      }
      this.$message({ message: "Success!", type: "success" });
      store.commit("setDialogVisible", false);
    },
  },
};
</script>

<style></style>
